const HERO_IMG =
    "https://customer-assets.emergentagent.com/job_serrurerie-atelier/artifacts/yo45r6j5_74abc5c1-80d6-4b5a-8f70-1594cbf88ec3.jpeg";

const HeroArtisanImage = () => (
    <div className="relative bg-white border border-black/10">
        <img
            src={HERO_IMG}
            alt="Artisan serrurier Atelier Beauchamp au travail"
            className="w-full aspect-square sm:aspect-auto sm:h-[520px] object-cover"
            loading="eager"
            data-testid="hero-artisan-image"
        />
        <div className="absolute top-4 left-4 bg-white border border-black/10 px-3 py-2 flex items-center gap-2">
            <span className="relative flex h-2 w-2">
                <span className="absolute inline-flex h-full w-full rounded-full bg-[#E63946] opacity-75 pulse-dot"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-[#E63946]"></span>
            </span>
            <span className="text-[11px] uppercase tracking-[0.18em] font-semibold">
                En ligne · répond maintenant
            </span>
        </div>
    </div>
);

export default HeroArtisanImage;
